import sortBy from 'lodash/sortBy';

export default {
    state: {
        tags: []
    },

    getters: {
        allTags (state) {
            return sortBy(state.tags, 'name');
        }
    },

    mutations: {
        ADD_TAG (state, payload) {
            state.tags.push(payload);
        },

        UPDATE_TAG (state, payload) {
            let originalTag = state.tags.find(t => t.id === payload.id);

            if (originalTag) {
                originalTag.name = payload.name;
            } else {
                state.tags.push(payload);
            }
        },

        DELETE_TAG (state, payload) {
            state.tags = state.tags.filter(t => t.id !== payload.id);
        },

        LOAD_TAGS (state, payload) {
            state.tags = payload;
        }
    },

    actions: {
        add ({ commit }, tag) {
            commit('ADD_TAG', tag);
        },

        update ({ commit }, tag) {
            commit('UPDATE_TAG', tag);
        },

        delete ({ commit }, tag) {
            commit('DELETE_TAG', tag);
        },

        load ({ commit }, tags) {
            commit('LOAD_TAGS', tags);
        }
    }
}
